import React, { useEffect, useState } from 'react';
import InfoAPI from '../components/InfoAPI';
import sessionSelectionImage from '../images/sessionSelection.png';
import sessionDefaultImage from '../images/session_default.png';
import { roundedCornersRadius } from '../utils/DisplaySettings';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';

// Navigation in open sessions

async function fetchSessionList(setSessionButtons, handleSessionButtonClick) {
  const requestBody = JSON.stringify({
    request_type: "info",
    info_type: "active_sessions"
  });

  const data = await InfoAPI(requestBody);
  const sessionsListParsed = JSON.parse(data.body);
  const sessionButtons = sessionsListParsed.map((session, index) => {
    const baseFontSize = 3;
    const textLength = session.length;
    const fontSize = Math.min(baseFontSize, (10 * baseFontSize) / textLength);

    return (
      <Col key={index} className="mb-4 d-flex justify-content-center">
        <div 
          onClick={() => handleSessionButtonClick(session)}
          style={{ 
            width: '100%',
            aspectRatio: '2/1',
            borderRadius: roundedCornersRadius,
            backgroundImage: `url(${sessionDefaultImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            fontSize: `${fontSize}rem`,
            fontWeight: 'bold',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textShadow: '0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.5)',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            padding: '2rem',
            minHeight: '12rem',
            maxWidth: '24rem',
            cursor: 'pointer',
            border: '2px solid white',
            color: 'white',
            transition: 'all 0.3s ease',
            backgroundColor: 'transparent'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            e.currentTarget.style.transform = 'scale(1.02)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          {session}
        </div>
      </Col>
    );
  });
  setSessionButtons(sessionButtons);
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

const Attend = () => {
  const [sessionButtons, setSessionButtons] = useState([]);
  const navigate = useNavigate();

  const handleSessionButtonClick = (session) => {
    localStorage.setItem('selectedSession', session);
    navigate(`/session/${encodeURIComponent(session)}`);
  };

  useEffect(() => {
    let mounted = true;

    const fetchSessions = async () => {
      if (mounted) {
        await fetchSessionList(setSessionButtons, handleSessionButtonClick);
      }
    };

    fetchSessions();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Container fluid className="mt-5">
      <Row className="justify-content-center mb-4">
        <Col xs={12} className="text-center">
          <Image 
            src={sessionSelectionImage} 
            alt="Session Selection" 
            fluid
            style={{ maxWidth: '100%' }}
          />
        </Col>
      </Row>
      <Row xs={1} md={2} lg={3} className="g-4 justify-content-center">
        {sessionButtons}
      </Row>
    </Container>
  );
};

export default Attend;